import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
import { createMnemonic, mnemonicToSeed, slip21Derive, } from "./Crypto.js";
export const Owner = Context.GenericTag("Owner");
export const makeOwner = (mnemonic) => Effect.gen(function* (_) {
    if (mnemonic == null)
        mnemonic = createMnemonic();
    const seed = mnemonicToSeed(mnemonic);
    const id = yield* Effect.map(slip21Derive(seed, ["Evolu", "Owner Id"]), (key) => {
        // convert key to nanoid
        let id = "";
        for (let i = 0; i < 21; i++) {
            id += urlAlphabet[key[i] & 63];
        }
        return id;
    });
    const encryptionKey = yield* slip21Derive(seed, [
        "Evolu",
        "Encryption Key",
    ]);
    return { mnemonic, id, encryptionKey };
});
// From https://github.com/ai/nanoid/blob/main/url-alphabet/index.js
// It's copy-pasted for now because NanoId import breaks Metro bundler.
// https://github.com/ai/nanoid/issues/468
const urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
